export interface Service {
  id: number;
  name: {
    ar: string;
    en: string;
  };
  description: {
    ar: string;
    en: string;
  };
  icon: string;
  route: string;
}

export const services: Service[] = [
  {
    id: 1,
    name: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'تحاليل دم شاملة ودقيقة',
      en: 'Comprehensive and accurate blood tests',
    },
    icon: 'TestTube',
    route: '/services/blood-tests',
  },
  {
    id: 2,
    name: {
      ar: 'الهرمونات',
      en: 'Hormone Panels',
    },
    description: {
      ar: 'فحص شامل للهرمونات',
      en: 'Comprehensive hormone testing',
    },
    icon: 'Heart',
    route: '/services/hormone-panels',
  },
  {
    id: 3,
    name: {
      ar: 'فحص الحساسية',
      en: 'Allergy Tests',
    },
    description: {
      ar: 'اختبارات الحساسية المتقدمة',
      en: 'Advanced allergy testing',
    },
    icon: 'Stethoscope',
    route: '/services/allergy-tests',
  },
  {
    id: 4,
    name: {
      ar: 'ملفات السكري',
      en: 'Diabetic Profiles',
    },
    description: {
      ar: 'فحوصات شاملة لمرضى السكري',
      en: 'Comprehensive diabetic testing',
    },
    icon: 'Microscope',
    route: '/services/diabetic-profiles',
  },
  {
    id: 5,
    name: {
      ar: 'مختبر الأطفال',
      en: 'Children Lab',
    },
    description: {
      ar: 'خدمات مختبرية متخصصة للأطفال',
      en: 'Specialized laboratory services for children',
    },
    icon: 'Baby',
    route: '/services/children-lab',
  },
  {
    id: 6,
    name: {
      ar: 'صحة المرأة',
      en: "Women's Health",
    },
    description: {
      ar: 'فحوصات صحية متخصصة للنساء',
      en: 'Specialized health tests for women',
    },
    icon: 'Heart',
    route: '/services/womens-health',
  },
  {
    id: 7,
    name: {
      ar: 'الحلول المؤسسية',
      en: 'Corporate Solutions',
    },
    description: {
      ar: 'خدمات مختبرية للشركات',
      en: 'Laboratory services for corporations',
    },
    icon: 'Building2',
    route: '/services/corporate-solutions',
  },
  {
    id: 8,
    name: {
      ar: 'الزيارات المنزلية',
      en: 'Home Visits',
    },
    description: {
      ar: 'خدمة سحب عينات من المنزل',
      en: 'Home sample collection service',
    },
    icon: 'Home',
    route: '/services/home-visits',
  },
];

